import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function PieChart({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>PieChart</title>
      <path
        d="M17.6569 17.6569C16.7266 18.5871 15.5812 19.2736 14.3223 19.6555C13.0633 20.0374 11.7296 20.1029 10.4393 19.8463C9.14895 19.5896 7.94183 19.0187 6.92485 18.1841C5.90788 17.3495 5.11242 16.2769 4.60896 15.0615C4.1055 13.846 3.90957 12.5251 4.03852 11.2159C4.16747 9.90659 4.61733 8.64933 5.34824 7.55544C6.07916 6.46155 7.06856 5.5648 8.22883 4.94463C9.38909 4.32446 10.6844 4 12 4L12 12L17.6569 17.6569Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 4C13.5823 4 15.129 4.46919 16.4446 5.34824C17.7602 6.22729 18.7855 7.47672 19.391 8.93853C19.9965 10.4003 20.155 12.0089 19.8463 13.5607C19.5376 15.1126 18.7757 16.538 17.6569 17.6569L12 12L12 4Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
